import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */
import DefaultLayout from "D:/work/BC_Supermarket/bc-supermarket-docs-docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h2 {...{
      "id": "banner-sizes"
    }}>{`Banner Sizes`}</h2>
<p><img alt="yellow style banner sizes" src={require("../img/home1-banner-sizes.png")} /></p>
<p><img alt="blue style banner sizes" src={require("../img/home2-banner-sizes.png")} /></p>
<p><img alt="product page banner sizes" src={require("../img/product-page-banner-sizes.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      